import React from "react";
import { ContractValuesDetails, DebitFGTSInstallments, ScreenResponsive } from "../../components";
import { observer } from "mobx-react-lite";
import { Box, Grid, skinVars, Text2, Text6 } from "@telefonica/mistica";
import { strings } from "../../localization";
import { formatAmount } from "../../utils/formatters";
import { useNavigateCustom } from "../../hooks";

const ContractDetails: React.FC = observer(() => {
	const navigate = useNavigateCustom();
	const { hiring } = strings.components.buttons;

	return (
		<ScreenResponsive isFooter isLogo navigationTitle={hiring} onBack={() => navigate(-1)}>
			<Grid justifyContent="center">
				<Grid alignItems="center" columns={{ maxSize: 392 }}>
					<Box paddingX={8} paddingTop={32} paddingBottom={24}>
						<Grid>
							<Text2 weight="regular" color={skinVars.colors.textSecondary}>
								{strings.components.ContractValuesDetails.fields.anticipationValue}
							</Text2>
							<Text6>{formatAmount(0)}</Text6>
						</Grid>
					</Box>
					<Box padding={8}>
						<ContractValuesDetails
							IOF={0}
							anticipationDate={"01/12/2023"}
							anticipationYears={0}
							blockedFGTSValue={0}
							contractFees={0}
							monthFees={0}
							yearsFees={0}
							tacAmount={0}
						/>
					</Box>
					<Box paddingBottom={32}>
						<DebitFGTSInstallments
							installments={[
								{
									data: "01/01/2024",
									value: 1222,
									status: "paid",
								},
								{
									data: "01/02/2024",
									value: 1222,
									status: "open",
								},
								{
									data: "01/03/2024",
									value: 1222,
									status: "open",
								},
							]}
						/>
					</Box>
				</Grid>
			</Grid>
		</ScreenResponsive>
	);
});

export default ContractDetails;
